import { Text } from '@vouched.id/vault';
import React from 'react';
export const DOBCaption = () => {
    return React.createElement(Text, { style: { marginBottom: '15px' } }, "DOB Verification");
};
